import React, { useState } from "react";
import img1 from "../../../Assets/imgcarousel/img1.png";
import img2 from "../../../Assets/imgcarousel/img2.png";
import img3 from "../../../Assets/imgcarousel/01.png";
import img4 from "../../../Assets/imgcarousel/02.png";
import "./ImgCarousel.css";

import leftbtn from "../../../Assets/left.png";
import rightbtn from "../../../Assets/right.png";
import ImgCarouselElement from "./ImgCarouselElement/ImgCarouselElement";
const ImgCarousel = () => {
  const [current, setCurrent] = useState(0);
  const imgArray = [img1, img2];
  const contentArray = [
    {
      img: img3,
      heading: "Talk about yourself",
      content:
        "I'm a blend of warmth and ambition, cherishing life's simple joys while reaching for dreams. Family-oriented, with a zest for adventure.",
    },
    {
      img:img4,
      heading: "Fix the Date & Blush",
      content:
        "Experience the Date & Blush feature—where chemistry ignites. Simply set a date, let sparks fly, and watch love bloom. Matrimonial magic made effortless.",
    },
  ];

  const handleNext = () => {
    if (current + 1 < 2) {
      setCurrent(current + 1);
    }
    let box = document.querySelector(".imgcarousel__content__wrapper");
    box.scrollLeft = box.scrollLeft + box.clientWidth;
  };

  const handlePref = () => {
    if (current - 1 >= 0) {
      setCurrent(current - 1);
    }
    let box = document.querySelector(".imgcarousel__content__wrapper");
    box.scrollLeft = box.scrollLeft - box.clientWidth;
  };

  return (
    <div className="imgcarousel">
      <div className="yuvraj-carousel">
        <div className="imgcarousel__images__wrapper">
          <div className="imgcarousel__images">
            <img className="carousel__img" src={imgArray[current]} alt="" />
            <img
              className="imgcarousel_btn imgcarousel_btn_left"
              src={leftbtn}
              onClick={handlePref}
              alt=""
            />
            <img
              className="imgcarousel_btn imgcarousel_btn_right"
              src={rightbtn}
              onClick={handleNext}
              alt=""
            />
          </div>
        </div>
        <div className="imgcarousel__content__wrapper">
          {contentArray.map((e) => (
            <div className="imgcarousel__content">
              <h2 className="mb-3 mt-4 text-start ms-5">{e.heading}</h2>
              <p className="text-start text-sm pt-5">{e.content}</p>
              <img src={e.img} alt="" className="img-position-number" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImgCarousel;
